// import Avocado from "../../images/Avocado.png";
// import Automobiles from "../../images/Automobiles.png";
import Mining from "../images/Mining.png";

const questionAnswers = [
  // Question 1
  [{
    index: 0,
    type: "international2",
    question: "Select the area on the graph that represents <b>Consumer Surplus</b>.",
    answer: [2], //3A
    numberAnswer: 0,
    answerDescription: "The area under the demand curve and above the price represents the gains to consumers from trade (consumer surplus). It is the difference between the maximum price they are willing to pay for a given quantity and the market price they actually paid.",
  },
  {
    index: 1,
    type: "international2",
    question: "Select the area on the graph that represents <b>Producer Surplus</b>.",
    answer: [5], //3A
    numberAnswer: 0,
    answerDescription: "The area above the supply curve and below the price represents the gains from trade for producers (producer surplus). It is the difference between the price they were actually paid and the minimum price they would accept for a given quantity.",
  },
  {
    index: 2,
    type: "international2",
    question: "Select the area on the graph that represents <b>Government Revenue</b> after the tax.",
    answer: [3,4], //3A
    numberAnswer: 50,
    answerDescription: "Government revenue is the amount of tax multiplied by the quantity sold. ($10 x 5 units = $50)",
  },
  {
    index: 3,
    type: "international2",
    question: "Select the area on the graph that represents <b>Producer Surplus</b> after the tax?",
    answer: [5],
    numberAnswer: 0,
    answerDescription: "The producer surplus is the area from their price (what the receive), P<sub>s </sub> , down to the supply curve (which represents their costs).",
  },
  {
    index: 4,
    type: "international2",
    question: "Select the area on the graph that represents <b>Consumer Surplus</b> after the tax?",
    answer: [2],
    numberAnswer: 0,
    answerDescription: "The consumer surplus is the area from their demand curve (which represents how they value the item) down to what they give up: their price (P<sub>b</sub>).",
  },
  {
    index: 5,
    type: "international2",
    question: "Select the area on the graph that represents the <b>Deadweight Loss</b> due to the tax?",
    answer: [6,7],
    numberAnswer: 0,
    answerDescription: "The total surplus after tax is the sum of consumer surplus, producer surplus and government revenue. The area that was a part of total surplus before the tax that is no longer in the surplus is the deadweight loss. It represents positive sum trades between buyers and sellers that have been pushed out of the market due to the tax.",
  },
  //description lines
  {
    buyerTax: 5,
    sellerTax: 5,
    governmentRevenue: 50,
    step: 10,
    isYes: false,
    subtitle: "Initially the equilibrium price is $10 and equilibrium quantity is 10.",
    subtitle2: "The $10 tax drives a wedge between buyers and sellers, the buyers now pay $15 and the sellers get only $5 after giving $10 to the government.",
    subtitle3: "Only 5 units are sold as that is all buyers will demand at a price of $15 and that’s the amount sellers will be willing to supply at a price of $5.",
    answerDescription: "The incidence is the difference between the new price after the tax and the price at equilibrium. Therefore, the buyer's incidence is $5, as the price they pay increases by $5 (from $10 to $15). The seller's incidence is also $5, as the price they receive decreases from $10 to $5. The incidence of the tax does not depend on who physically pays the tax. Both buyers and sellers are always affected when either is taxed."
  }],
// question 2
  [{
    index: 0,
    type: "international2",
    question: "Select the area on the graph that represents <b>Consumer Surplus</b>.",
    answer: [2], //3A
    numberAnswer: 0,
    answerDescription: "The area under the demand curve and above the price represents the gains to consumers from trade (consumer surplus). It is the difference between the maximum price they are willing to pay for a given quantity and the market price they actually paid.",
  },
  {
    index: 1,
    type: "international2",
    question: "Select the area on the graph that represents <b>Producer Surplus</b>.",
    answer: [5], //3A
    numberAnswer: 0,
    answerDescription: "The area above the supply curve and below the price represents the gains from trade for producers (producer surplus). It is the difference between the price they were actually paid and the minimum price they would accept for a given quantity.",
  },
  {
    index: 2,
    type: "international2",
    question: "Select the area on the graph that represents <b>Government Revenue</b> after the tax.",
    answer: [3,4], //3A
    numberAnswer: 18,
    answerDescription: "Government revenue is the amount of tax multiplied by the quantity sold. ($9 x 2 units = $18)",
  },
  {
    index: 3,
    type: "international2",
    question: "Select the area on the graph that represents <b>Producer Surplus</b> after the tax?",
    answer: [5],
    numberAnswer: 0,
    answerDescription: "The producer surplus is the area from their price (what the receive), P<sub>s </sub> , down to the supply curve (which represents their costs).",
  },
  {
    index: 4,
    type: "international2",
    question: "Select the area on the graph that represents <b>Consumer Surplus</b> after the tax?",
    answer: [2],
    numberAnswer: 0,
    answerDescription: "The consumer surplus is the area from their demand curve (which represents how they value the item) down to what they give up: their price (P<sub>b</sub>).",
  },
  {
    index: 5,
    type: "international2",
    question: "Select the area on the graph that represents the <b>Deadweight Loss</b> due to the tax?",
    answer: [6,7],
    numberAnswer: 0,
    answerDescription: "The total surplus after tax is the sum of consumer surplus, producer surplus and government revenue. The area that was a part of total surplus before the tax that is no longer in the surplus is the deadweight loss. It represents positive sum trades between buyers and sellers that have been pushed out of the market due to the tax.",
  },
  //description lines
  {
    buyerTax: 6,
    sellerTax: 3,
    governmentRevenue: 18,
    step: 2,
    isYes: false,
    subtitle: "Initially the equilibrium price is $5 and equilibrium quantity is 5.",
    subtitle2: "The $9 tax drives a wedge between buyers and sellers, the buyers now pay $11 and the sellers get only $2 after giving $9 to the government.",
    subtitle3: "Only 2 units are supplied as that is all buyers will demand at a price of $11 and that’s the amount sellers will be willing to supply at a price of $2.",
    answerDescription: "The incidence is the difference between the new price after the tax and the price at equilibrium. Therefore, the buyer's incidence is $6, as the price they pay increases by $6 (from $5 to $11). The seller's incidence is  $3, as the price they receive decreases from $5 to $2. The incidence of the tax does not depend on who physically pays the tax. Both buyers and sellers are always affected when either is taxed."
  }],
  // question 3
  [{
    index: 0,
    type: "international2",
    question: "Select the area on the graph that represents <b>Consumer Surplus</b>.",
    answer: [2], //3A
    numberAnswer: 0,
    answerDescription: "The area under the demand curve and above the price represents the gains to consumers from trade (consumer surplus). It is the difference between the maximum price they are willing to pay for a given quantity and the market price they actually paid.",
  },
  {
    index: 1,
    type: "international2",
    question: "Select the area on the graph that represents <b>Producer Surplus</b>.",
    answer: [5], //3A
    numberAnswer: 0,
    answerDescription: "The area above the supply curve and below the price represents the gains from trade for producers (producer surplus). It is the difference between the price they were actually paid and the minimum price they would accept for a given quantity.",
  },
  {
    index: 2,
    type: "international2",
    question: "Select the area on the graph that represents <b>Government Revenue</b> after the tax.",
    answer: [3,4], //3A
    numberAnswer: 20,
    answerDescription: "Government revenue is the amount of tax multiplied by the quantity sold. ($10 x 2 units = $20)",
  },
  {
    index: 3,
    type: "international2",
    question: "Select the area on the graph that represents <b>Producer Surplus</b> after the tax?",
    answer: [5],
    numberAnswer: 0,
    answerDescription: "The producer surplus is the area from their price (what the receive), P<sub>s </sub> , down to the supply curve (which represents their costs).",
  },
  {
    index: 4,
    type: "international2",
    question: "Select the area on the graph that represents <b>Consumer Surplus</b> after the tax?",
    answer: [2],
    numberAnswer: 0,
    answerDescription: "The consumer surplus is the area from their demand curve (which represents how they value the item) down to what they give up: their price (P<sub>b</sub>).",
  },
  {
    index: 5,
    type: "international2",
    question: "Select the area on the graph that represents the <b>Deadweight Loss</b> due to the tax?",
    answer: [6,7],
    numberAnswer: 0,
    answerDescription: "The total surplus after tax is the sum of consumer surplus, producer surplus and government revenue. The area that was a part of total surplus before the tax that is no longer in the surplus is the deadweight loss. It represents positive sum trades between buyers and sellers that have been pushed out of the market due to the tax.",
  },
  //description lines
  {
    buyerTax: 2,
    sellerTax: 8,
    governmentRevenue: 20,
    step: 2,
    isYes: false,
    subtitle: "Initially the equilibrium price is $12 and equilibrium quantity is 6.",
    subtitle2: "The $10 tax drives a wedge between buyers and sellers, the sellers get $4, which is the market price, the buyers pay a total of $14 after including the $10 tax to the government.",
    subtitle3: "Only 2 units are supplied as that is all buyers will demand at a price of $14 and that’s the amount sellers will be willing to supply at a price of $4.",
    answerDescription: "The incidence is the difference between the new price after the tax and the price at equilibrium. Therefore, the buyer's incidence is $2, as the price they pay increases by $2 (from $12 to $14). The seller's incidence is  $8, as the price they receive decreases from $12 to $4. The incidence of the tax does not depend on who physically pays the tax. Both buyers and sellers are always affected when either is taxed."
  }]
];

export default questionAnswers;
